angular
  .module("myApp")
  .controller("UserListController", function ($scope, $state, Dialog, uuiData, NewUser) {
    this.newUser = () =>
      this.createUser({
        ir_aktivs: true,
        ir_lzp_postdoc_admin: false,
        ir_1112: false,
        meta_role: "LIETOTAJS",
        existing: false,
        pwd_mode: "email",
        eksperts: {
          zin_grads: [],
          nozare: [],
        },
      })
    this.newExpert = () =>
      this.createUser({
        ir_aktivs: true,
        ir_lzp_postdoc_admin: false,
        ir_1112: false,
        meta_role: "LIETOTAJS",
        existing: false,
        pwd_mode: "email",
        eksperts: {
          zin_grads: [],
          nozare: [],
        },
      })
    this.createUser = (u) => {
      u.ev_check = () => {
        u.warning = void 0
        u.error = void 0
        if (!u.epasts) {
          return true
        }
        if (u.epasts === u.orig_epasts) {
          return true
        }
        return uuiData.list(
          "lietotajs_autofill",
          {
            epasts: u.epasts,
          },
          (l) => {
            u.existing = false
            u.pwd_mode = "email"
            if (l.length === 0) {
              return
            }
            const uu = l[0]
            u.warning = "Lietotājs ar šādu e-pasta adresi jau ir reģistrēts."
            u.existing = true
            u.pwd_mode = "none"
            u.vards = uu.vards
            u.uzvards = uu.uzvards
            u.telefons = uu.telefons
            u.personas_kods = uu.personas_kods
            u.amats = uu.amats
            u.ir_aktivs = uu.ir_aktivs
            if (uu.eksperts) {
              u.ir_eksperts = true
              uu.eksperts.liguma_datums = moment(uu.eksperts.liguma_datums).toDate()
              u.eksperts = uu.eksperts
            }
          }
        )
      }
      return Dialog.dialog("pages/dialogs/user.user-new.form.html", u, { wide: true }, (user, action) => {
        if (action === "save") {
          const a = new NewUser(user)
          return Dialog.finish(a, () => {
            $state.go("app.user.edit.open", {
              id: a.id,
            })
          })
        }
      })
    }
    $scope.gridOptions = {
      filtersUrl: "pages/user/user-filter.html",
      defaultFilters: {},
      initialFilters: {},
      noDataLabel: "Nav atrasts neviens lietotājs.",
      rowClick: (row) =>
        $state.go("app.user.edit", {
          id: row.id,
        }),
      renderers: {
        arejais_eksperts_id: (n) => {
          if (n) {
            return "Eksperts"
          }
          return ""
        },
      },
      buttons: [
        {
          label: "Izveidot jaunu lietotāju",
          class: "btn-success",
          icon: "fa-plus",
          click: this.newUser,
        },
      ],
    }
    if ($state.$current.name === "app.user.list-experts") {
      $scope.view = "lietotajs_list_experts"
      $scope.gridOptions.buttons[0].label = "Pievienot jaunu ekspertu"
      $scope.gridOptions.buttons[0].click = this.newExpert
    } else if ($state.$current.name === "app.user.list-lzp") {
      $scope.view = "lietotajs_list_lzp"
    } else if ($state.$current.name === "app.user.list-org") {
      $scope.view = "lietotajs_list_org"
    } else {
      $scope.view = "lietotajs_list"
    }
  })
  .controller(
    "UserEditController",
    function (
      $scope,
      $controller,
      Dialog,
      Notification,
      Codifiers,
      SaveUserOverview,
      AssignUserOrg,
      UnassignUserOrg
    ) {
      $controller("BaseEditController", {
        $scope: $scope,
      })
      $scope.dto_view = "lietotajs_overview"
      $scope.editable = true
      $scope.kla = Codifiers.kla

      $scope.decode_meta = {
        LIETOTAJS: "Lietotājs",
        LZP: "LZP darbinieks",
        LZP_VADITAJS: "LZP struktūrvienības vadītājs",
        LZP_AUDITORS: "LZP auditors",
      }

      $scope.afterLoad = () => {
        $scope.dto.ir_eksperts = false
        if ($scope.dto.exp.length > 0) {
          $scope.dto.ir_eksperts = true
          $scope.dto.eksperts = $scope.dto.exp[0]
          if ($scope.dto.eksperts.liguma_datums) {
            $scope.dto.eksperts.liguma_datums = moment($scope.dto.eksperts.liguma_datums).toDate()
          }
        } else {
          $scope.dto.eksperts = {
            statuss: "Aktīvs",
            vai_piedalas_vertesana: true,
          }
        }
      }
      this.unassignUznemums = (u) => {
        if (!confirm("Atsaistīt lietotāju no uzņēmuma?")) {
          return
        }
        const a = new UnassignUserOrg({
          adm_lietotajs_id: $scope.dto.id,
          uznemums_id: u.uznemums_id,
        })
        return a.$create(
          () => {
            Notification.success("Uzņēmums atsaistīts")
            return $scope.reload()
          },
          (e) => Notification.error(e.data)
        )
      }
      this.assignUznemums = () => {
        var x
        x = {
          title: "Piesaistīt uzņēmumam",
          uzn_loma: "DARBINIEKS",
        }
        return Dialog.dialog("pages/dialogs/org-choose.form.html", x, (x) => {
          const a = new AssignUserOrg({
            adm_lietotajs_id: $scope.dto.id,
            uznemums_id: x.uznemums_id,
            uzn_loma: x.uzn_loma,
          })
          return Dialog.finish(a, () => {
            Notification.success("Uzņēmums piesaistīts")
            $scope.reload()
          })
        })
      }

      $scope.save = () => {
        const dto = $scope.dto
        const d = new SaveUserOverview({
          id: dto.id,
          vards: dto.vards,
          uzvards: dto.uzvards,
          personas_kods: dto.personas_kods,
          amats: dto.amats,
          telefons: dto.telefons,
          parole: dto.parole,
          ir_aktivs: dto.ir_aktivs,
          epasts: dto.epasts,
          ir_piekritis_apstradei: dto.ir_piekritis_apstradei,
          meta_role: dto.meta_role,
          ir_1112: dto.ir_1112,
          ir_lzp_postdoc_admin: dto.ir_lzp_postdoc_admin,
          ir_eksperts: dto.ir_eksperts,
          eksperts: dto.eksperts,
        })
        return d.$save(
          () => {
            Notification.success("Izmaiņas saglabātas")
            $scope.reload()
            $scope.editMode = false
          },
          (err) => Notification.error(err.data ? err.data : "Datus saglabāt neizdevās.")
        )
      }
      $scope.reload()
      return this
    }
  )
